import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/core/loader/loader.service';
import { UserCacheService } from 'src/app/core/user/user-cache.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  isAuthenticated: boolean = false;
  language: string;
  hideContent: boolean = true;
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private userService: UserCacheService
  ) {}

  ngOnInit(): void {
    this.navigateToExistingRouteIfLanguageExists();
    this.loaderService.isLoadingSubject.subscribe((isLoading) => {
      this.hideContent = isLoading;
    });

    if (!!this.userService.get()) {
      this.isAuthenticated = true;
    } else {
      this.isAuthenticated = false;
    }
  }

  redirectTo() {
    this.router.navigate(['login']);
  }

  navigateToExistingRouteIfLanguageExists() {
    if (this.router.url.split('/').indexOf('dashboard') > 0) {
      this.language =
        this.router.url.split('/')[
          this.router.url.split('/').indexOf('dashboard') - 1
        ];
    }
    if (this.language) {
      const indexOfLanguage = this.router.url.indexOf(`/${this.language}`);
      const routeToNavigate = this.router.url.substring(
        indexOfLanguage + this.language.length + 1
      );
      this.router.navigate([routeToNavigate]);
    }
  }
}
